import React from "react";
import PasswordReset from "../components/PasswordReset";

const ResetPassowrdPage = () => {
  return (
    <>

      {/* ForgotPasswordLayer */}
      <PasswordReset />

    </>
  );
};

export default ResetPassowrdPage;
